import { useEffect, useState } from "react";
import {
  getConnectivityState,
  retryConnectivityNow,
  subscribeConnectivity,
} from "services/connectivityMonitor";

/**
 * Subscribes a component to the connectivity monitor
 * (`services/connectivityMonitor.js`) — same module-store + subscriber
 * pattern as `hooks/usePrivacyMode.js`.
 *
 * Returns:
 * - `status`         'idle' | 'checking' | 'server-down' | 'no-internet'
 * - `attempt`        completed failure checks in the current episode
 * - `lastCheckedAt`  epoch ms of the last completed check (null before the
 *                    first one)
 * - `isReconnecting` true while the reconnect overlay should be on screen
 * - `isServerDown`   true for the X verdict (server restarting/crashed)
 * - `isNoInternet`   true for the Y verdict (device is offline)
 * - `retryNow`       run a check immediately instead of waiting for the tick
 */
export const useConnectivity = () => {
  const [connectivity, setConnectivity] = useState(getConnectivityState);

  useEffect(() => subscribeConnectivity(setConnectivity), []);

  const { status, attempt, lastCheckedAt } = connectivity;

  return {
    status,
    attempt,
    lastCheckedAt,
    isReconnecting: status !== "idle",
    isServerDown: status === "server-down",
    isNoInternet: status === "no-internet",
    retryNow: retryConnectivityNow,
  };
};

export default useConnectivity;
